import module from 'module';

const templateUrl = require('./cashier-cash-shortage.template.html');
module.component('cashierCashShortage', {
  templateUrl: templateUrl,
  controller: function (actionCommand) {
    this.transaction = {};

    this.denominationIsValid = () => {
      return this.transaction.denominationBundle != null && this.transaction.denominationValid;
    };

    this.cancelChanges = () => actionCommand.cancelChanges();

    this.save = () => actionCommand.execute('CASHIER_CASH_SHORTAGE', this.transaction);
  }
});
